/**
 * FieldText component themable props.
 */
import { stringLiteralArray } from "../../utils"

export default {
  appearances: stringLiteralArray([
    "flag",
    "error",
    "hint",
    "required",
    "field-label"
  ])
}
